<template>
  <div>
    <div v-if="isLoaded">
      <b-row class="mb-2">
        <b-col offset="9" md="3">
          <Print elementToPrintId="contentToPrint" buttonName="Drukuj wszystko"></Print>
        </b-col>
      </b-row>

      <div id="contentToPrint">
        <DeliverySummaryForm
          v-for="item in items"
          :key="item.id"
          :src="item"
          :is-last="items.slice(-1).id === item.id"
        />
      </div>
    </div>
    <div v-show="!isLoaded">
      <Loading ref="loadingSpinner"></Loading>
    </div>
  </div>
</template>

<script>
import DeliverySummaryForm from "./DeliverySummaryForm";
import Loading from "../../Common/Loading";
import Print from "../../Common/Print";
import RawMaterialMixins from "../../../mixins/rawMaterials";

export default {
  mixins: [RawMaterialMixins],
  components: { DeliverySummaryForm, Loading, Print },
  mounted() {
    var deliverySummaryID = this.$route.params.id;
    this.loadInitData(deliverySummaryID);
  },
  data() {
    return {
      items: [],
      isLoaded: false,
    };
  },
  methods: {
    loadInitData(deliveryId) {
      var that = this;

      this.getRawMaterialDeliveries(deliveryId)
        .then(function (response) {
          that.items = response.data;
        })
        .catch(function (e) {
          console.log(e);
          var ref = that.$refs.loadingSpinner;
          ref.ShowErrorMessage(e);
          that.isLoaded = false;
        })
        .finally(function () {
          that.isLoaded = true;
        });
    },
  },
};
</script>
